import React from 'react';
import { FiGithub, FiLinkedin, FiTwitter, FiMail } from 'react-icons/fi';
import profilePic from '../assets/images/profile/profile-picture.jpeg';

const skills = [ 'Any programming language with AI',
  'C#', '.NET', 'AngularJS', 'SQL Server',
  'JavaScript', 'TypeScript', 'React', 'Node.js',
  'Python', 'Redis', 'Azure DevOps', 'Azure AI',
  'Docker', 'Kubernetes', 'AWS', 'System Design',
  'CI/CD', 'GraphQL', 'Microservices',
];

const Sidebar = ({ className = '' }) => {
  return (
    <aside className={`sidebar ${className}`}>
      <div className="sidebar-photo">
        <img src={profilePic} alt="Bhavik K. Rupa" className="sidebar-photo-img" />
      </div>

      <div className="sidebar-identity">
        <h2 className="sidebar-name">Bhavik K. Rupa</h2>
        <p className="sidebar-role">Technical Lead | Solution Expert | Cloud Enthusiast       </p>
      </div>

      <p className="sidebar-bio">
        Building AI-driven tools before the singularity . Builds and Blogs about AI based applications, architecture
        and delivers them faster than ever.
      </p>

      <div className="sidebar-divider" />

      <div>
        <div className="sidebar-section-label">Skills</div>
        <div className="sidebar-skills" style={{ marginTop: 8 }}>
          {skills.map((skill) => (
            <span key={skill} className="skill-btn">{skill}</span>
          ))}
        </div>
      </div>

      <div className="sidebar-divider" />

      <div>
        <div className="sidebar-section-label">Connect</div>
        <div className="sidebar-links" style={{ marginTop: 8 }}>
          <a
            href="https://github.com/thewickedengineer"
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-link"
            title="GitHub"
          >
            <FiGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/bhavik-rupa-b9670b68"
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-link"
            title="LinkedIn"
          >
            <FiLinkedin />
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-link"
            title="Twitter / X"
          >
            <FiTwitter />
          </a>
          <a
            href="mailto:hello@thewickedengineer.com"
            className="sidebar-link"
            title="Email"
          >
            <FiMail />
          </a>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
